export enum DataSources {
  cognito = "cognito",
  mysql = "mysql",
  dynamo = "dynamo",
}

export enum DataAPI {
  userPool = "userPool",
  estates = "estates", // mysql estates api
  users = "users", // mysql users api
  usersProfile = "user-profile",
  businesses = "businesses", // table to be created
}

export type DataDef = {
  source: DataSources;
  api: DataAPI;
  fields: string[];
};
